import getApiClient from '@/plugins/api'

export default {
    load: function () {
        const self = this;
        const hash = this.$route.params.hash
        const api = getApiClient(self.$store)

        self.vaidator = this.$route.fullPath.indexOf('validator') > -1

        self.$store.commit('startLoading')

        self.validateTicket(hash, self, api)
            .then(function(responseBoardingPass) {
                self.order = responseBoardingPass.order
                self.ticketValid = responseBoardingPass.valid
                self.urlQrCode = responseBoardingPass.urlValidation
                self.ticketMessage = responseBoardingPass.valid ? self.validMessage : self.invalidMessage

            }).catch(function(error) {
                self.ticketMessage = self.invalidMessage
            }).finally(function() {
                self.$store.commit('stopLoading')
            })
    },
    validateTicket: function (ticket, self, api) {
        return new Promise(function(resolve, reject) {
            api.get(`/boarding_passes/${ticket}`)
                .then((result) => { resolve(result.data) })
                .catch((error) => { reject(error) })
        });

    },
    getImageAgency(path) {
        return this.baseUrl + path
    },
    getImageCadastur() {
        return this.baseUrl + this.cadasturImagePath
    },
    getQrCode() {
        return `${process.env.VUE_APP_API_URL}/boarding_passes/qrcode/${this.$route.params.hash}`
    }
}
